var RING_BUILDER_FILTERS = {
  filterColors: [
    {
      id: 1,
      title: "D",
      value: "d",
      queryValue: "D",
      type: "color",
    },
    {
      id: 2,
      title: "E",
      value: "e",
      queryValue: "E",
      type: "color",
    },
    {
      id: 3,
      title: "F",
      value: "f",
      queryValue: "F",
      type: "color",
    },
    {
      id: 4,
      title: "G",
      value: "g",
      queryValue: "G",
      type: "color",
    },
    {
      id: 5,
      title: "H",
      value: "h",
      queryValue: "H",
      type: "color",
    },
  ],
  filterClarities: [
    {
      id: 1,
      title: "FL",
      value: "fl",
      queryValue: "FL",
      type: "clarity",
    },
    {
      id: 2,
      title: "IF",
      value: "if",
      queryValue: "IF",
      type: "clarity",
    },
    {
      id: 3,
      title: "VVS1",
      value: "vvs1",
      queryValue: "VVS1",
      type: "clarity",
    },
    {
      id: 4,
      title: "VVS2",
      value: "vvs2",
      queryValue: "VVS2",
      type: "clarity",
    },
    {
      id: 5,
      title: "VS1",
      value: "vs1",
      queryValue: "VS1",
      type: "clarity",
    },
    {
      id: 6,
      title: "VS2",
      value: "vs2",
      queryValue: "VS2",
      type: "clarity",
    },
  ],
  filterShapes: [
    {
      id: 1,
      title: "Round Brilliant",
      value: "round-brilliant",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape.png?v=1670497175",
      queryValue: "Round",
      type: "shape",
    },
    {
      id: 2,
      title: "Oval",
      value: "oval",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-1.png?v=1670497175",
      queryValue: "Oval",
      type: "shape",
    },
    {
      id: 3,
      title: "Cushion",
      value: "cushion",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-2.png?v=1670497174",
      queryValue: "Cushion",
      type: "shape",
    },
    {
      id: 4,
      title: "Emerald",
      value: "emerald",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-3.png?v=1670497175",
      queryValue: "Emerald",
      type: "shape",
    },
    {
      id: 5,
      title: "Radiant",
      value: "radiant",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-4.png?v=1670497175",
      queryValue: "Radiant",
      type: "shape",
    },
    {
      id: 6,
      title: "Pear",
      value: "pear",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-5.png?v=1670497175",
      queryValue: "Pear",
      type: "shape",
    },
    {
      id: 7,
      title: "Princess",
      value: "princess",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Princess-new.png?v=1686754619",
      queryValue: "Princess",
      type: "shape",
    },
    {
      id: 8,
      title: "Marquise",
      value: "marquise",
      image:
        "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Marquise-new.png?v=1686754619",
      queryValue: "Marquise",
      type: "shape",
    },
    {
      id: 9,
      title: "Antique Cushion",
      value: "Antique Cushion",
      image: "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Antique_Cushion_png.png?v=1756886819",
      queryValue: "Antique Cushion",
      type: "shape",
    },
    {
      id: 10,
      title: "Elongated Cushion",
      value: "elongated-cushion",
      image: "https://cdn.shopify.com/s/files/1/0745/7102/2619/files/Stone_elongated-cushion.png?v=1766400345",
      queryValue: "Elongated Cushion",
      type: "shape"
    }
  ],
};
